module.exports = __webpack_public_path__ + "static/pod-intro-img-mobile-2-396b4ca8136809bab52f7ec97d7859f8.png";